(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lf-collection-hub"] && !Shopify.designMode) return;
  try {
    
  class LfchCarousel {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('.lfch-carousel__track');
      this.dotsWrap = el.querySelector('.lfch-carousel__dots');
      if (!this.track) return;
      this.slides = Array.from(this.track.children);
      this.interval = parseInt(el.dataset.autoplay, 10) || 0;
      this.index = 0;
      this.timer = null;
      this.buildDots();
      this.bind();
      this.startAuto();
    }

    buildDots() {
      if (!this.dotsWrap || this.slides.length < 2) return;
      this.slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'lfch-carousel__dot';
        b.setAttribute('aria-label', 'Ir al producto ' + (i + 1));
        b.addEventListener('click', () => this.go(i, true));
        this.dotsWrap.appendChild(b);
      });
      this.dots = Array.from(this.dotsWrap.children);
      this.updateDots();
    }

    bind() {
      this.el.querySelectorAll('.lfch-carousel__nav').forEach((btn) => {
        btn.addEventListener('click', () => this.go(this.index + parseInt(btn.dataset.dir, 10), true));
      });
      let t;
      this.track.addEventListener('scroll', () => {
        clearTimeout(t);
        t = setTimeout(() => {
          const w = this.track.clientWidth || 1;
          this.index = Math.round(this.track.scrollLeft / w);
          this.updateDots();
        }, 90);
      }, { passive: true });
      this.el.addEventListener('mouseenter', () => this.stopAuto());
      this.el.addEventListener('mouseleave', () => this.startAuto());
      this.el.addEventListener('focusin', () => this.stopAuto());
      this.el.addEventListener('focusout', () => this.startAuto());
      this.el.addEventListener('touchstart', () => this.stopAuto(), { passive: true });
    }

    go(i, user) {
      const n = this.slides.length;
      if (!n) return;
      this.index = ((i % n) + n) % n;
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'smooth' });
      this.updateDots();
      if (user) { this.stopAuto(); this.startAuto(); }
    }

    updateDots() {
      if (!this.dots) return;
      this.dots.forEach((d, i) => d.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
    }

    startAuto() {
      if (!this.interval || this.slides.length < 2) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stopAuto();
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    }

    stopAuto() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }
  }

  function initLfchCarousels(root) {
    (root || document).querySelectorAll('.lfch-carousel').forEach((el) => {
      if (!el.__lfchCarousel) { el.__lfchCarousel = new LfchCarousel(el); }
    });
  }

  if (document.readyState !== 'loading') {
    initLfchCarousels();
  } else {
    document.addEventListener('DOMContentLoaded', () => initLfchCarousels());
  }
  document.addEventListener('shopify:section:load', (e) => initLfchCarousels(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-header-categories"] && !Shopify.designMode) return;
  try {
    
  function initLfCatmenuTrigger(root) {
    (root || document).querySelectorAll('a[href="#lf-categorias-menu"]').forEach((link) => {
      if (link.__lfCatmenuBound) return;
      link.__lfCatmenuBound = true;
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const cb = document.getElementById('LfCatmenuDrawer');
        if (!cb) return;
        cb.checked = true;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  if (document.readyState !== 'loading') {
    initLfCatmenuTrigger();
  } else {
    document.addEventListener('DOMContentLoaded', () => initLfCatmenuTrigger());
  }
  document.addEventListener('shopify:section:load', (e) => initLfCatmenuTrigger(e.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lf-instagram-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      var track = root.querySelector('[data-track]');
      if (!track) return;
      var items = Array.from(track.children);
      if (!items.length) return;

      function step(dir) {
        var w = items[0].getBoundingClientRect().width + 14.4; // + gap
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }

      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      var interval = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
      if (interval > 0 && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        var timer = setInterval(function () {
          var atEnd = Math.ceil(track.scrollLeft + track.clientWidth) >= track.scrollWidth;
          if (atEnd) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            step(1);
          }
        }, interval);
        root.addEventListener('mouseenter', function () { clearInterval(timer); });
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-ig-carousel]').forEach(function (el) {
        if (!el.__igGallery) {
          el.__igGallery = true;
          initGallery(el);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
